import React from "react";
import CategoryPicker from "./CategoryPicker";
import InlineLoading from "./InlineLoading";

const DEFAULT_ALL_ITEM = { id: "all", label: "Todos", initial: "T" };

const CategoryFilterBar = ({
  categories = [],
  selectedCategory,
  onSelect,
  includeAll = true,
  allItem = DEFAULT_ALL_ITEM,
  loading = false,
  loadingMessage = <InlineLoading label="Cargando categorías" />,
  error,
  emptyMessage = "No hay categorías disponibles.",
  isEmpty,
  itemsWrapperClassName = "",
}) => {
  return (
    <CategoryPicker
      categories={categories}
      selectedCategory={selectedCategory}
      onSelect={onSelect}
      includeAll={includeAll}
      allItem={allItem}
      layout="scroll"
      compact
      loading={loading}
      loadingMessage={loadingMessage}
      error={error}
      emptyMessage={emptyMessage}
      isEmpty={isEmpty ?? categories.length === 0}
      itemsWrapperClassName={itemsWrapperClassName}
      scrollClassName="flex items-center gap-1.5 overflow-x-auto pb-1"
    />
  );
};

export default CategoryFilterBar;
